import PageLayout from "@/components/feature/PageLayout";
import SectionHeader from "@/components/feature/SectionHeader";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import LatestSection from "@/pages/home/components/LatestSection";
import HotRanking from "@/pages/home/components/HotRanking";
import { movies } from "@/mocks/movies";
import { useSeo } from "@/hooks/useSeo";

const stats = [
  { label: "影视作品", value: "12,000+", icon: "ri-video-line" },
  { label: "内容分类", value: "3 大类", icon: "ri-list-check-2" },
  { label: "每日更新", value: "50+", icon: "ri-loop-left-line" },
  { label: "覆盖地区", value: "10+", icon: "ri-earth-line" },
];

export default function Home() {
  useSeo({
    title: "樱桃视频-优质影视内容聚合与视频播放平台",
    description:
      "樱桃视频为您提供丰富的影视内容，包括最新电影、电视剧和热门综艺，支持多类型视频浏览与搜索，满足您的观影需求。",
    keywords: "樱桃视频,影视视频,电影,电视剧,视频播放,影视内容,视频平台",
  });

  return (
    <PageLayout>
      <HeroCarousel />

      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6">
        <section className="mt-10 md:mt-14">
          <SectionHeader title="分类快捷入口" subtitle="按类型快速找到你想看的内容" />
          <CategoryEntry />
        </section>

        <section className="mt-12 md:mt-16 grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <SectionHeader title="最新影视" subtitle="按更新时间排序，每日持续更新" />
            <LatestSection movies={movies} />
          </div>
          <aside>
            <SectionHeader title="热门排行榜" subtitle="按播放量实时统计" />
            <HotRanking movies={movies} />
          </aside>
        </section>

        <section className="mt-12 md:mt-16 mb-4">
          <div className="relative rounded-lg overflow-hidden border border-background-200 bg-background-100 p-6 md:p-10">
            <div className="relative z-10 flex flex-col lg:flex-row lg:items-center gap-8">
              <div className="flex-1">
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-50 text-primary-500 text-xs font-bold mb-4">
                  <i className="ri-movie-2-line"></i>
                  关于樱桃视频
                </span>
                <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-950 mb-3">
                  优质影视内容，一站聚合
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl">
                  樱桃视频专注于影视内容的资讯聚合与分类浏览，汇集最新电影、热播电视剧与人气综艺。
                  你可以按类型、地区、年份多维筛选，查看作品详情与相关推荐，快速找到想看的内容。
                  平台播放区域为演示性质，鼓励大家支持正版影视内容。
                </p>
                <div className="flex flex-wrap gap-6 mt-6">
                  {stats.map((s) => (
                    <div key={s.label} className="flex items-center gap-3">
                      <span className="w-11 h-11 rounded-lg bg-background-200 flex items-center justify-center text-primary-500">
                        <i className={`${s.icon} text-xl`}></i>
                      </span>
                      <span className="flex flex-col leading-tight">
                        <span className="font-heading font-black text-lg text-foreground-950">
                          {s.value}
                        </span>
                        <span className="text-xs text-foreground-500">{s.label}</span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="w-full lg:w-72 h-48 lg:h-64 shrink-0 rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=cozy%20dark%20home%20cinema%20scene%20with%20popcorn%20and%20warm%20ambient%20lighting%2C%20glowing%20screen%20reflection%2C%20deep%20charcoal%20and%20crimson%20tones%2C%20inviting%20movie%20night%20atmosphere%2C%20cinematic%20still%20life&width=800&height=800&seq=cherry-intro-01&orientation=squarish"
                  alt="樱桃视频 影视观看场景"
                  title="樱桃视频 影视内容聚合"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-primary-500/10 blur-2xl"></div>
          </div>
        </section>
      </div>
    </PageLayout>
  );
}